module.exports = __webpack_public_path__ + "static/logo-secondary-075ad4bfcd29e70c3276018c83dc46a6.png";